// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import Core from '@/until/core'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

Vue.use(Vuex)
Vue.use(ViewUI)
Vue.config.productionTip = false
const store = new Vuex.Store({
  state: {
    hasLogin: false,
    UserData: {}
  },
  mutations: {
    onChangeHasLogin (state, value) {
      state.hasLogin = value
    },
    setUserData (state, value) {
      state.UserData = value
    }
  },
  actions: {
    // 获取用户相关信息
    getUserInfo ({commit}) {
      return new Promise((resolve, reject) => {
        Core('/Auction/User/UserCenter').then(res => {
          if (!res.error_code || res.data) {
            commit('setUserData', res.data)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  getters: {
    UserData: state => state.UserData
  }
})
router.beforeEach((route, redirect, next) => {
  // 进入页面前
  if (Core.getAccessToken()) {
    store.commit('onChangeHasLogin', true)
    store.dispatch('getUserInfo')
  } else {
    if (route.name !== 'Login') {
      next({
        name: 'Login'
      })
    }
  }
  next()
})
router.afterEach((route) => {
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js